(() => {
  const loaderScript = document.currentScript;
  const searchScopeSelector = 'predictive-search, details-modal.header__search, .search-modal';
  const eventTypes = ['pointerdown', 'focusin', 'input', 'keydown'];
  let loadPromise = null;

  const resolveCoreUrl = () => {
    const url = new URL(loaderScript.src, document.baseURI);
    url.pathname = url.pathname.replace(/predictive-search\.js$/, 'bpc-predictive-search-core-v1.js');
    return url.href;
  };

  const findSearchScope = (target) =>
    target instanceof Element ? target.closest(searchScopeSelector) : null;

  const findActiveSearchInput = (scope) => {
    if (
      document.activeElement instanceof HTMLInputElement &&
      document.activeElement.matches('input[type="search"]') &&
      document.activeElement.closest('predictive-search')
    ) {
      return document.activeElement;
    }

    return scope?.querySelector?.('predictive-search input[type="search"], input[type="search"]') || null;
  };

  const replayPendingInput = (scope) => {
    const input = findActiveSearchInput(scope);
    if (input?.value) {
      input.dispatchEvent(new Event('input', { bubbles: true }));
    }
  };

  const removeIntentListeners = () => {
    eventTypes.forEach((type) => document.removeEventListener(type, onSearchIntent, true));
  };

  const loadPredictiveSearchCore = (scope) => {
    if (customElements.get('predictive-search')) {
      replayPendingInput(scope);
      return Promise.resolve();
    }

    if (loadPromise) {
      return loadPromise.then(() => replayPendingInput(scope));
    }

    loadPromise = new Promise((resolve) => {
      const script = document.createElement('script');
      script.src = resolveCoreUrl();
      script.async = true;
      script.dataset.bpcPredictiveCore = 'true';
      script.onload = () => {
        delete document.documentElement.dataset.bpcPredictiveLoadError;
        removeIntentListeners();
        replayPendingInput(scope);
        resolve();
      };
      script.onerror = () => {
        document.documentElement.dataset.bpcPredictiveLoadError = 'true';
        loadPromise = null;
        resolve();
      };
      document.head.appendChild(script);
    });

    return loadPromise;
  };

  function onSearchIntent(event) {
    const scope = findSearchScope(event.target);
    if (!scope) return;

    if (event.type === 'keydown') {
      const targetIsSearchInput =
        event.target instanceof HTMLInputElement && event.target.matches('input[type="search"]');
      const keyCanActivateSearch = event.key === 'Enter' || event.key === ' ' || event.key.length === 1;
      if (!targetIsSearchInput && !keyCanActivateSearch) return;
    }

    loadPredictiveSearchCore(scope);
  }

  eventTypes.forEach((type) => {
    document.addEventListener(type, onSearchIntent, {
      capture: true,
      passive: type === 'pointerdown',
    });
  });
})();
